import Vue from 'vue'

export async function getProductos(context, [access_token, params, con_loading]) {
    
    try {
        if (access_token) {
            if (con_loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/productos/stock-disponible/dashboard',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })
            console.log('response:', response);
            if (response.status == 200 && response.data.productos) {
                context.commit('inventario/setProductos', response.data.productos, { root: true })
            }
        }

    } catch (e) {
    } finally {
        if (con_loading){
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getProducto(context, [access_token, id, con_loading]) {
    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/productos/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            if (response.status == 200 && response.data && response.data.data) {
                context.commit('inventario/setProductoSelec', response.data.data, { root: true })
            }
            return response;
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function updateProducto(context, [access_token, modelProducto]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'PUT',
                url: '/productos/' + modelProducto.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelProducto
            })
            if (response.status == 200 && response.data && response.data.data) {
                context.commit('inventario/actListProductos', response.data.data, { root: true })
                context.commit('inventario/setProductoSelec', response.data.data, { root: true })
            }
            return response;
        }

    } catch (e) {
    } finally {
    }
}
